module.exports = "/Public/build/32598b5936c21c240e7d115feeded025.svg";


//////////////////
// WEBPACK FOOTER
// ./data/assets/feature-article-logo-color.svg
// module id = 834
// module chunks = 0